export const bundlesPtBr = {
  title: 'Processamento de documentos',
  trigger: {
    label: 'Fila',
    badgeEmpty: '0',
  },
  tabs: {
    processing: 'Processando',
    completed: 'Concluído',
  },
  status: {
    processing: 'Processando',
    completed: 'Concluído',
    failed: 'Falhou',
    cancelled: 'Cancelado',
    queueEmpty: '0 em andamento',
    inProgressCount: '{{count}} em andamento',
    failedCount_one: '{{count}} envio com falha',
    failedCount_other: '{{count}} envios com falha',
    viewFailures: 'Ver falha',
  },
  cancel: {
    button: 'Cancelar',
    title: 'Cancelar processamento deste bundle?',
    description:
      'Arquivos ainda não vinculados a contas serão removidos da fila. Documentos já vinculados permanecem intactos.',
    dismiss: 'Voltar',
    confirm: 'Cancelar processamento',
    busy: 'Cancelando...',
    success: 'Processamento do bundle cancelado.',
    error: 'Não foi possível cancelar o bundle',
  },
  startup: {
    title: 'Preparando processamento do bundle',
    description:
      '{{count}} arquivo(s) enviado(s). Estamos criando o plano de processamento; isso pode levar alguns segundos.',
    badge: 'Iniciando',
    cancelUnavailable: 'A opção de cancelar aparecerá assim que o envio criar o bundle.',
  },
  passwordRequired: {
    title: 'PDF protegido por senha',
    description: 'Informe a senha do documento para continuar o processamento.',
    label: 'Senha do PDF {{documentName}}',
    placeholder: 'Digite a senha do PDF',
    submit: 'Enviar senha',
    submitting: 'Enviando...',
    success: 'Senha validada. O documento voltará ao processamento.',
    error: 'Não foi possível validar a senha. Confira a senha e tente novamente.',
    emptyError: 'Informe a senha para continuar.',
  },
  sections: {
    completedSession: 'Concluídos nesta sessão',
  },
  steps: {
    CLASSIFY_DOCUMENTS: 'Classificando documentos',
    EXTRACT_INFORMATION: 'Extraindo informações',
    ANALYZE_CONTEXT: 'Analisando contexto',
    BUILD_ACTION_PLAN: 'Montando plano de ação',
    CREATE_OR_LINK_BILLS: 'Criando/vinculando contas',
    countSummary: '{{done}} de {{total}}',
    failureReason: '{{documentName}}: {{reason}}',
    unknown: 'Etapa do processamento',
  },
  files: {
    count: '{{count}} arquivo(s)',
    countWithAge: '{{count}} arquivo(s) • {{age}}',
  },
  completed: {
    viewBill: 'Ver conta',
    viewBills: 'Ver contas',
    created: '{{count}} conta(s) criada(s)',
    linked: 'Documento associado a uma conta existente',
    noBill: 'Processamento concluído',
    expandBills: 'Ver contas deste envio',
    collapseBills: 'Ocultar contas',
    dismiss: 'Dispensar',
    billWithDocuments: '{{documentName}} (+{{extraCount}})',
    colVendor: 'Fornecedor',
    colAmount: 'Valor',
    colHint: 'Tipo',
    hintCreated: 'Criada',
    hintLinked: 'Vinculada',
    partialSuccess: '{{bills}} conta(s), {{failures}} falha(s)',
    partialSkipped: '{{bills}} conta(s), {{skipped}} ignorado(s)',
    failedDocumentsTitle: '{{count}} documento(s) com falha',
    failedDocumentFallback:
      'Não foi possível processar este documento. Tente novamente; se o problema continuar, fale com o suporte.',
    retryDocument: 'Tentar novamente',
    retryingDocument: 'Reprocessando...',
    retryDocumentSuccess: 'Documento reenfileirado para reprocessamento.',
    retryDocumentError: 'Não foi possível reprocessar o documento.',
    cancelDocument: 'Cancelar',
    cancellingDocument: 'Cancelando...',
    cancelDocumentTitle: 'Cancelar este documento?',
    cancelDocumentDescription:
      'O documento será removido permanentemente deste envio. Você poderá reenviar o arquivo em seguida.',
    cancelDocumentConfirm: 'Cancelar documento',
    cancelDocumentSuccess: 'Documento cancelado.',
    cancelDocumentError: 'Não foi possível cancelar o documento.',
    manualBillCreationRequired:
      'Não foi possível criar a conta automaticamente. Crie a conta manualmente e anexe o arquivo diretamente, sem usar o processamento por IA.',
    internationalTaxIdCountryConflict:
      'O identificador fiscal estrangeiro está cadastrado com país {{registeredCountry}}, mas o documento indica {{documentCountry}}. Confira o país do fornecedor e tente novamente.',
    unknownCountry: 'não informado',
    preassignmentFailed:
      'Não foi possível preparar este documento para criar a conta. Tente novamente; se o erro continuar, fale com o suporte.',
    noVendorOrAmount:
      'A extração terminou, mas não identificou fornecedor ou valor válido. Confira o arquivo e tente novamente; se necessário, crie a conta manualmente.',
    processingStalled:
      'O processamento não avançou por mais de 30 minutos. Cancele este envio e envie os arquivos pendentes novamente; se o problema continuar, fale com o suporte.',
    cancelStalled: 'Cancelar envio travado',
    cancelStalledTitle: 'Cancelar o processamento deste envio?',
    cancelStalledConfirm: 'Cancelar processamento',
    skippedDocumentsTitle: '{{count}} documento(s) ignorado(s)',
    skippedDocumentFallback: 'Este documento foi ignorado pelo processamento automático.',
    documentTypePlaceholder: 'Escolher ação',
    skipOption: 'Ignorar',
    skipHelp: 'Manter este documento ignorado e não criar conta.',
    confirmSkip: 'Confirmar',
    retry: 'Tentar novamente',
    retrying: 'Reprocessando...',
    retrySuccess: 'Documento reenfileirado para reprocessamento.',
    retryError: 'Não foi possível reprocessar o documento.',
    linkManual: 'Vincular a esta conta',
    linkingManual: 'Vinculando...',
    linkManualHelp: 'Use quando o documento já existe, mas não foi vinculado automaticamente.',
    linkManualSuccess: 'Documento vinculado a esta conta.',
    linkManualError: 'Não foi possível vincular o documento a esta conta.',
    deleteFailed: 'Excluir',
    deletingFailed: 'Excluindo...',
    deleteFailedTitle: 'Excluir documentos com falha?',
    deleteFailedDescription:
      'Os documentos com falha serão removidos permanentemente. Você poderá reenviar os arquivos em seguida.',
    deleteFailedConfirm: 'Excluir',
    deleteFailedSuccess: 'Documentos excluídos. Você pode reenviar os arquivos.',
    deleteFailedError: 'Não foi possível excluir os documentos.',
    retryFailed: 'Tentar novamente',
    retryingFailed: 'Reenfileirando...',
    retryFailedSuccess: 'Documentos reenfileirados para reprocessamento.',
    retryFailedError: 'Não foi possível reprocessar os documentos.',
    documentTypeOptions: {
      BOLETO: 'Boleto',
      NFE_SERVICO: 'NF-e serviço',
      NFE_PRODUTO: 'NF-e produto',
      BOLETO_COM_NF: 'Boleto com NF',
      CARD_INVOICE: 'Fatura de cartão',
      INTERNATIONAL_INVOICE: 'Invoice internacional',
      TELECOM_BILL: 'Conta de telecom',
      UTILITIES_BILL: 'Conta de consumo',
      DARF: 'DARF',
      GPS: 'GPS',
      GUIA_ISS: 'Guia ISS',
      GUIA_ICMS: 'Guia ICMS',
      GRF: 'GRF',
      DAS: 'DAS',
      COMPROVANTE_PAGAMENTO: 'Comprovante de pagamento',
      CUPOM_FISCAL: 'Cupom fiscal',
      RECIBO_PLATAFORMA: 'Recibo de plataforma',
      RECIBO_GENERICO: 'Recibo genérico',
    },
  },
  empty: {
    processing: 'Nenhum bundle em processamento.',
    completed: 'Nenhum bundle concluído nesta sessão.',
  },
  errors: {
    refresh: 'Falha ao carregar status dos bundles',
  },
};

export const bundlesEn = {
  title: 'Document processing',
  trigger: {
    label: 'Queue',
    badgeEmpty: '0',
  },
  tabs: {
    processing: 'Processing',
    completed: 'Completed',
  },
  status: {
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
    queueEmpty: '0 in progress',
    inProgressCount: '{{count}} in progress',
    failedCount_one: '{{count}} upload failed',
    failedCount_other: '{{count}} uploads failed',
    viewFailures: 'View failure',
  },
  cancel: {
    button: 'Cancel',
    title: 'Cancel this bundle processing?',
    description:
      'Files that are not linked to bills yet will be removed from the queue. Already linked documents stay intact.',
    dismiss: 'Back',
    confirm: 'Cancel processing',
    busy: 'Cancelling...',
    success: 'Bundle processing cancelled.',
    error: 'Unable to cancel bundle',
  },
  startup: {
    title: 'Preparing bundle processing',
    description:
      '{{count}} file(s) uploaded. We are creating the processing plan; this may take a few seconds.',
    badge: 'Starting',
    cancelUnavailable: 'Cancel will appear as soon as the upload creates the bundle.',
  },
  passwordRequired: {
    title: 'Password-protected PDF',
    description: 'Enter the document password to continue processing.',
    label: 'PDF password for {{documentName}}',
    placeholder: 'Enter the PDF password',
    submit: 'Submit password',
    submitting: 'Submitting...',
    success: 'Password accepted. The document will resume processing.',
    error: 'Could not validate the password. Check the password and try again.',
    emptyError: 'Enter the password to continue.',
  },
  sections: {
    completedSession: 'Completed this session',
  },
  steps: {
    CLASSIFY_DOCUMENTS: 'Classifying documents',
    EXTRACT_INFORMATION: 'Extracting information',
    ANALYZE_CONTEXT: 'Analyzing context',
    BUILD_ACTION_PLAN: 'Building action plan',
    CREATE_OR_LINK_BILLS: 'Creating/linking bills',
    countSummary: '{{done}} of {{total}}',
    failureReason: '{{documentName}}: {{reason}}',
    unknown: 'Processing step',
  },
  files: {
    count: '{{count}} file(s)',
    countWithAge: '{{count}} file(s) • {{age}}',
  },
  completed: {
    viewBill: 'View bill',
    viewBills: 'View bills',
    created: '{{count}} bill(s) created',
    linked: 'Document linked to an existing bill',
    noBill: 'Processing completed',
    expandBills: 'Show bills from this upload',
    collapseBills: 'Hide bills',
    dismiss: 'Dismiss',
    billWithDocuments: '{{documentName}} (+{{extraCount}})',
    colVendor: 'Vendor',
    colAmount: 'Amount',
    colHint: 'Type',
    hintCreated: 'Created',
    hintLinked: 'Linked',
    partialSuccess: '{{bills}} bill(s), {{failures}} failure(s)',
    partialSkipped: '{{bills}} bill(s), {{skipped}} skipped',
    failedDocumentsTitle: '{{count}} failed document(s)',
    failedDocumentFallback:
      'This document could not be processed. Retry; if the problem continues, contact support.',
    retryDocument: 'Retry',
    retryingDocument: 'Reprocessing...',
    retryDocumentSuccess: 'Document queued for reprocessing.',
    retryDocumentError: 'Could not reprocess the document.',
    cancelDocument: 'Cancel',
    cancellingDocument: 'Cancelling...',
    cancelDocumentTitle: 'Cancel this document?',
    cancelDocumentDescription:
      'The document will be permanently removed from this upload. You can re-upload the file afterwards.',
    cancelDocumentConfirm: 'Cancel document',
    cancelDocumentSuccess: 'Document cancelled.',
    cancelDocumentError: 'Could not cancel the document.',
    manualBillCreationRequired:
      'The bill could not be created automatically. Create the bill manually and attach the file directly without AI processing.',
    internationalTaxIdCountryConflict:
      'The foreign tax ID is registered under {{registeredCountry}}, but the document indicates {{documentCountry}}. Check the vendor country and retry.',
    unknownCountry: 'unknown',
    preassignmentFailed:
      'This document could not be prepared to create a bill. Retry; if the problem continues, contact support.',
    noVendorOrAmount:
      'Extraction finished, but no valid vendor or amount was found. Check the file and retry; if needed, create the bill manually.',
    processingStalled:
      'Processing has not advanced for over 30 minutes. Cancel this upload and upload the pending files again; if the problem continues, contact support.',
    cancelStalled: 'Cancel stalled upload',
    cancelStalledTitle: 'Cancel processing for this upload?',
    cancelStalledConfirm: 'Cancel processing',
    skippedDocumentsTitle: '{{count}} skipped document(s)',
    skippedDocumentFallback: 'This document was skipped by automatic processing.',
    documentTypePlaceholder: 'Choose action',
    skipOption: 'Skip',
    skipHelp: 'Keep this document skipped and do not create a bill.',
    confirmSkip: 'Confirm',
    retry: 'Retry',
    retrying: 'Reprocessing...',
    retrySuccess: 'Document queued for reprocessing.',
    retryError: 'Could not reprocess the document.',
    linkManual: 'Link to this bill',
    linkingManual: 'Linking...',
    linkManualHelp: 'Use this when the document exists but was not linked automatically.',
    linkManualSuccess: 'Document linked to this bill.',
    linkManualError: 'Could not link the document to this bill.',
    deleteFailed: 'Delete',
    deletingFailed: 'Deleting...',
    deleteFailedTitle: 'Delete failed documents?',
    deleteFailedDescription:
      'The failed documents will be permanently removed. You can re-upload the files afterwards.',
    deleteFailedConfirm: 'Delete',
    deleteFailedSuccess: 'Documents deleted. You can re-upload the files.',
    deleteFailedError: 'Could not delete the documents.',
    retryFailed: 'Retry',
    retryingFailed: 'Re-queuing...',
    retryFailedSuccess: 'Documents re-queued for reprocessing.',
    retryFailedError: 'Could not reprocess the documents.',
    documentTypeOptions: {
      BOLETO: 'Boleto',
      NFE_SERVICO: 'Service NF-e',
      NFE_PRODUTO: 'Product NF-e',
      BOLETO_COM_NF: 'Boleto with invoice',
      CARD_INVOICE: 'Credit card statement',
      INTERNATIONAL_INVOICE: 'International invoice',
      TELECOM_BILL: 'Telecom bill',
      UTILITIES_BILL: 'Utility bill',
      DARF: 'DARF',
      GPS: 'GPS',
      GUIA_ISS: 'ISS tax guide',
      GUIA_ICMS: 'ICMS tax guide',
      GRF: 'GRF',
      DAS: 'DAS',
      COMPROVANTE_PAGAMENTO: 'Payment receipt',
      CUPOM_FISCAL: 'Fiscal receipt',
      RECIBO_PLATAFORMA: 'Platform receipt',
      RECIBO_GENERICO: 'Generic receipt',
    },
  },
  empty: {
    processing: 'No bundle is processing.',
    completed: 'No bundle completed in this session.',
  },
  errors: {
    refresh: 'Failed to load bundle status',
  },
};
